import { ErrorHandler, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { AngularCommonModule } from '../angular-common/angular-common.module';

import { BreadcrumbsComponent } from './components/breadcrumbs/breadcrumbs.component';
import { FacilitySelectorComponent } from './components/facility-selector/facility-selector.component';
import { FacilitySelectorSearchDialog } from './components/facility-selector/facility-selector-search.dialog';

import { LoaderFillComponent } from './components/loaders/loader-fill/loader-fill.component';

import { ErrorRobotComponent } from './components/errors/error-robot/error-robot.component';

import { FacilitySelectorService } from './services/facility-selector.service';
import { AuthManagerService } from './services/auth-manager.service';
import { DialogService } from './services/dialog.service';
import { UrlService } from './services/url.service';
import { CanDeactivateGuard } from './guards/can-deactivate.guard';
import { TimeoutDialog } from './components/dialogs/timeout-dialog/timeout-dialog.component';
import { ConfirmDialog } from './components/dialogs/confirm-dialog/confirm-dialog.component';
import { SafeHtmlPipe } from './pipes/safe-html.pipe';
import { UserService } from './services/user.service';
import { StartEndDateValidatorDirective } from './directives/start-end-date-validator.directive';
import { StartEndTimeValidatorDirective } from './directives/start-end-time-validator.directive';
import { DatePickerHiddenComponent } from './components/datepickerhidden/datepickerhidden.component';
import { FileUploaderComponent } from './components/file-uploader/file-uploader.component';
import { SheetUploaderComponent } from './components/sheet-uploader/sheet-uploader.component';
import { DragndDropFileDirective } from './directives/drag-and-drop-file.directive';
import { OverlayComponent } from './components/overlay/overlay.component';
import { OverlayService } from './services/overlay.service';
import { StringFilterByPipe } from '../shared/pipes/search.pipe';
import { StorageService } from './services/storage.service';
import { ArrayHelperService } from './services/array-helper.service';
import { OdataHelperService } from './services/odata-helper.service';
import { AegisGridComponent } from './components/aegis-grid/aegis-grid.component';
import { AegisGridOptionsDialogComponent } from './components/aegis-grid-options-dialog/aegis-grid-options-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { RollbarErrorHandler, RollbarService, rollbarFactory } from '../core/services/rollbar';
import { ErrorHandlerService } from './services/error-handler.service';
import { NgxMaskModule, optionsConfig } from 'ngx-mask';
import { MinusSignToParens } from './pipes/minusSignToParens.pipe';

const maskConfig: Partial<optionsConfig> = {
  validation: false
};

@NgModule({
  imports: [
    CommonModule,
    AngularCommonModule,
    RouterModule,
    DragDropModule,
    NgxMaskModule.forRoot(),
  ],
  declarations: [
    BreadcrumbsComponent,
    FacilitySelectorComponent,
    FacilitySelectorSearchDialog,
    TimeoutDialog,
    ConfirmDialog,
    LoaderFillComponent,
    ErrorRobotComponent,
    SafeHtmlPipe,
    StartEndDateValidatorDirective,
    StartEndTimeValidatorDirective,
    DatePickerHiddenComponent,
    FileUploaderComponent,
    SheetUploaderComponent,
    DragndDropFileDirective,
    OverlayComponent,
    StringFilterByPipe,
    AegisGridComponent,
    AegisGridOptionsDialogComponent,
    MinusSignToParens
  ],
  exports: [
    BreadcrumbsComponent,
    FacilitySelectorComponent,
    FacilitySelectorSearchDialog,
    LoaderFillComponent,
    ErrorRobotComponent,
    SafeHtmlPipe,
    StartEndDateValidatorDirective,
    StartEndTimeValidatorDirective,
    DatePickerHiddenComponent,
    FileUploaderComponent,
    SheetUploaderComponent,
    DragndDropFileDirective,
    StringFilterByPipe,
    AegisGridComponent,
    ErrorHandlerService,
    MinusSignToParens
  ],
  providers: [
    FacilitySelectorService,
    AuthManagerService,
    UrlService,
    DialogService,
    CanDeactivateGuard,
    UserService,
    OverlayService,
    StorageService,
    ArrayHelperService,
    OdataHelperService,
    { provide: ErrorHandler, useClass: RollbarErrorHandler },
    { provide: RollbarService, useFactory: rollbarFactory }
  ]
})
export class SharedModule { }
